module.exports = __webpack_public_path__ + "img/wz-8-7-1.ebb7da34.jpg";